import { render, staticRenderFns } from "./DashboardCompany.vue?vue&type=template&id=c89bc04a"
import script from "./DashboardCompany.vue?vue&type=script&lang=js"
export * from "./DashboardCompany.vue?vue&type=script&lang=js"
import style0 from "./DashboardCompany.vue?vue&type=style&index=0&id=c89bc04a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports